import React, { useEffect } from "react";
import "./App.css";
import Homepage from "./pages/homepage";
import GoogleMyBusinessPage from "./pages/google-my-business-page";
import { Routes, Route } from "react-router-dom";
import {
  HOME,
  INDEX,
  GMB,
  INITIATIVE,
  BOOKING_PAGE,
  ONE_KB_INITIATIVE,
  ERA_TEK_DISCOVERY,
  TALENT_REQUISITION_FORM,
  WILD_CARD,
} from "./routes/paths.routes";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactGA from "react-ga";
import BookingPage from "./pages/booking-page";
import OneKBInitiative from "./pages/initiatives";
import { TalentRequisitionFormPage } from "./pages/talent-requisition";
import { EratekDiscoveryBookingPage } from "./pages/eratek-discovery-call";
import "react-multi-carousel/lib/styles.css";
import NotFound from "./components/not-found/NotFound";
import { clarity } from "react-microsoft-clarity";
import { ENV, PROD_ENV, constants } from "./constants/constant";














// TODO: Update TRACKING_ID to actual ID
// Start Google Analytics Code
const TRACKING_ID = "UA-XXXXX-X"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
// End Google Analytics Code


const MICROSOFT_CLARITY_ID = constants().MICROSOFT_CLARITY_ID;


function App() {








  useEffect(() => {
    AOS.init({
      delay: 100,
    });
    AOS.refresh();
  }, []);



  // initialize Microsoft Clarity for analytics in prod
  if (ENV === PROD_ENV) clarity.init(MICROSOFT_CLARITY_ID);








  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route element={<Homepage />} path={HOME} />
        <Route element={<Homepage />} path={INDEX} />

        <Route element={<BookingPage />} path={BOOKING_PAGE} />
        <Route
          element={<EratekDiscoveryBookingPage />}
          path={ERA_TEK_DISCOVERY}
        />
        <Route
          element={<TalentRequisitionFormPage />}
          path={TALENT_REQUISITION_FORM}
        />

        <Route element={<GoogleMyBusinessPage />} path={GMB} />

        <Route element={<OneKBInitiative />} path={INITIATIVE} />
        <Route element={<OneKBInitiative />} path={ONE_KB_INITIATIVE} />

        <Route
          path={WILD_CARD}
          element={<NotFound error="Sorry, but that page cannot be found!" />}
        />
      </Routes>
    </>
  );
}

export default App;
